<template>
  <div class="Container" v-if="UserProfile === 'SUP'">
    <h2 class="ViewHeading">Water Management Company User Admin</h2>

    <b-container>
      <h5 class="pageHeader">Select WMC Admin Action</h5>

      <div class="tab">
        <button
          v-if="selectedAction != 'AddClient'"
          class="reportTabLeft"
          v-on:click="selectedAction = 'AddClient'"
        >
          Add WMC User
        </button>
        <button
          v-if="selectedAction == 'AddClient'"
          class="reportTabActiveLeft"
          v-on:click="selectedAction = 'AddClient'"
        >
          Add WMC User
        </button>

        <button
          v-if="selectedAction != 'DeactWMC'"
          class="reportTabRight"
          v-on:click="showModal('WMCDeactivateModal')"
        >
          Remove WMC User
        </button>
        <button
          v-if="selectedAction == 'DeactWMC'"
          class="reportTabActiveRight"
          v-on:click="selectedAction = 'DeactWMC'"
        >
          Remove WMC User
        </button>
      </div>

      <div class="tabcontent">
        <span class="SelectionRow" v-if="selectedAction == 'AddClient'">
          <div class="tabBottom">
            <div class="tabcontent">
              <span class="SelectionRow" v-if="selectedAction == 'AddClient'">
                <h3>WMC User Add Form</h3>

                <b-row>
                  <b-col sm="3">
                    <p id="FormText">First Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="First Name"
                      v-model="fName"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Last Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Last Name"
                      v-model="lName"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Department</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Department"
                      v-model="wmcDept"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Company</p>
                  </b-col>
                  <b-col sm="3">
                    <select v-model="wmcCompany">
                      <option value="" select disabled>Select Company</option>
                      <option
                        v-for="(value, id) in this.companyArray"
                        :key="id"
                        v-bind:value="{ id: value.id, text: value.name }"
                        >{{ value.name }}</option
                      >
                    </select>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Email Address</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Email Address"
                      v-model="wmcEmail"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="AddNewWMCAUTH0()"
                    >
                      Submit
                    </button>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="resetForm()"
                    >
                      Clear
                    </button>
                  </b-col>
                </b-row>
              </span>
            </div>
          </div>
        </span>

        <span class="SelectionRow" v-if="selectedAction == 'DeactWMC'">
          <div class="tabBottom">
            <div class="tabcontent">
              <span class="SelectionRow" v-if="selectedAction == 'DeactWMC'">
                <h3>WMC User Inactivation Form</h3>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">Name</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Name"
                      v-model="wmcToDelete.Name"
                      required
                      readonly
                      @focus="modal = false"
                    />
                  </b-col>
                  <b-col sm="3">
                    <p id="FormText">Location</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="Location"
                      v-model="wmcToDelete.Locations"
                      required
                      readonly
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <p id="FormText">User URN</p>
                  </b-col>
                  <b-col sm="3">
                    <input
                      type="text"
                      placeholder="URN"
                      v-model="wmcToDelete.UserURN"
                      required
                      @focus="modal = false"
                    />
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="inactivateWMCUser()"
                    >
                      Submit
                    </button>
                    <button
                      class="AdminButton"
                      @focus="modal = false"
                      v-on:click="resetForm()"
                    >
                      Clear
                    </button>
                  </b-col>
                </b-row>
              </span>
            </div>
          </div>
        </span>
      </div>

      <!-------------------------------------------------------------------------------------------------------------------- 
-->

      <b-modal
        ref="WMCDeactivateModal"
        id="WMCDeactivateModal"
        hide-footer
        title=" Water Management Company User Lookup Form"
        content-class="Modal"
      >
        <div>
          <h3>Search by user's name</h3>
          <input
            maxlength="45"
            type="text"
            v-model="UserFirstNameSearch"
            placeholder="First Name"
          />
          <input
            maxlength="45"
            type="text"
            v-model="UserSurnameSearch"
            placeholder="Last Name"
          />
          <br />
          <button class="button" v-on:click="LookUpSubmit('WMCDeactivate')">
            Submit
          </button>
          <button class="button" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal>

      <b-modal
        ref="WMCSelectionModal"
        id="WMCSelectionModal"
        hide-footer
        title="WMC Selection Form"
        content-class="Modal"
      >
        <div>
          <h3>Select WMC User</h3>

          <select v-model="wmcSelection">
            <option value="" select disabled>Select User</option>
            <option
              v-for="(value, id) in this.wmcListArray"
              :key="id"
              v-bind:value="{
                UserURN: value.UserURN,
                Name: value.Name,
                Locations: value.Locations,
              }"
              >{{ value.Name + " - " + value.Locations }}</option
            >
          </select>

          <br />
          <button class="AdminButton" v-on:click="wmcSelect()">
            Submit
          </button>
          <button class="AdminButton" v-on:click="resetForm()">
            Clear
          </button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  methods: {
    showModal(Modal) {
      this.DivID = "";
      this.$refs[Modal].show();
    },
    hideModal(Modal) {
      this.$refs[Modal].hide();
    },
    resetForm() {
      this.selectedAction = "";
      this.DivID = "";
      (this.deactclURN = ""),
        (this.deactclFName = ""),
        (this.deactclLName = ""),
        (this.deactclDept = ""),
        (this.deactclLoc = ""),
        (this.fName = ""),
        (this.lName = "");
      this.clDept = "";
      this.clLocation = "";
      this.clEmail = "";
      this.DeviceRequestNo = "";
      this.messageforNewLocationEmail = "";
      this.wmcDept = "";
      this.wmcCompany = "";
      this.wmcEmail = "";
      this.wmcLocation = "";
      this.UserSurnameSearch = "";
      this.UserFirstNameSearch = "";
      this.wmcToDelete = "";
      this.selectedSearch = "";
    },

    AddNewWMCAUTH0() {
      var randomNo1 = Math.floor(Math.random() * 9);
      var randomNo2 = Math.floor(Math.random() * 9);
      var randomNo3 = Math.floor(Math.random() * 9);
      var randomNo4 = Math.floor(Math.random() * 9);

      let totalNo = randomNo1.toString(10);
      totalNo = totalNo + randomNo2.toString(10);
      totalNo = totalNo + randomNo3.toString(10);
      totalNo = totalNo + randomNo4.toString(10);
      let nickname = "";
      nickname = "";
      nickname = this.fName.slice(0, 3) + this.lName.slice(0, 3);
      nickname = nickname + totalNo;

      let name = this.fName + " " + this.lName;

      if (
        (this.wmcEmail != "") &
        (this.wmcCompany != "") &
        (this.fName != "") &
        (this.lName != "") &
        (this.wmcDept != "")
      ) {
        let LookUpURLAuth0 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/auth0";
        let LookUpHeadersAuth0 = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "Create",
          Email: this.wmcEmail,
          UserMetaCompany: this.wmcCompany.text,
          UserMetaLocation: "",
          AppMetaAccess: "WaterManagement",
          AppMetaPortal: "WMC",
          FirstName: this.fName,
          LastName: this.lName,
          Name: name,
          UserID: "",
          Username: nickname,
        };

        axios
          .post(LookUpURLAuth0, this.LookUpRequest, LookUpHeadersAuth0)
          .then((response) => {
            this.wmcURN = response.data.Values.user_id;
            this.AddNewWMCDB();
          });
      }
    },

    AddNewWMCDB() {
      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "User",
        Action: "Create",
        Type: "WMC",
        DataDict: [
          {
            UserURN: this.wmcURN,
            FirstName: this.fName,
            LastName: this.lName,
            Department: this.wmcDept,
            Company: this.wmcCompany.text,
          },
        ],
      };
      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          this.HistoryNote = "Added WMC";
          alert("Water Management Company User has been created");
        });
    },

    inactivateWMCUser() {
      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "User",
        Action: "Delete",
        Type: "WMC",
        DataDict: [{ UserURN: this.wmcToDelete.UserURN }],
      };
      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          this.HistoryNote = "Inactivated WMC";
          this.resetForm();
          alert("Water Management Company User has been inactivated");
        });
    },

    wmcSelect() {
      this.wmcToDelete = this.wmcSelection;
      this.hideModal("WMCSelectionModal");
      this.selectedAction = "DeactWMC";
    },

    HistorySubmit() {
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });

      let LookUpURLHist =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/adminhistory";
      let LookUpHeadersHist = this.$apikeyPost;
      this.LookUpRequest = {
        UserURN: this.UserURN,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: this.HistoryNote,
        ProfilePortal: this.UserProfile,
      };

      axios
        .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
        .then((response) => {
          response;
        });
    },

    LookUpSubmit: function(Lookup) {
      if (Lookup === "WMCDeactivate") {
        let LookUpURLCl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/sulookups";
        let LookUpHeadersCl = this.$apikeyPost;
        let LookUpRequestCl = {
          RequestType: "CompanyUser",
          RequestVariable: "",
          FirstName: this.UserFirstNameSearch,
          LastName: this.UserSurnameSearch,
        };

        axios
          .post(LookUpURLCl, LookUpRequestCl, LookUpHeadersCl)
          .then((response) => {
            if (response.data.Values == "Invalid Name") {
              alert("Please ensure the name entered is correct");
            } else if (response.data.Values[1] == null) {
              this.wmcList = "";
              this.wmcList = response.data.Values;
              this.wmcSelection = [];
              this.wmcToDelete = {};
              this.wmcSelection.push({
                UserURN: this.wmcList[0][0],
                Name: this.wmcList[0][1],
                Company: this.wmcList[0][2],
              });
              this.wmcToDelete = this.wmcSelection[0];

              this.hideModal("WMCDeactivateModal");
              this.selectedAction = "DeactWMC";
              this.UserFirstNameSearch = "";
              this.UserSurnameSearch = "";
            } else if (response.data.Values[1] != "") {
              this.wmcList = "";
              this.wmcList = response.data.Values;
              for (let i = 0; i < this.wmcList.length; i++) {
                /*  var QuoteStr1 = this.clientList[i][0] */
                this.wmcListArray.push({
                  UserURN: this.wmcList[i][0],
                  Name: this.wmcList[i][1],
                  Company: this.wmcList[i][2],
                });
              }
              this.hideModal("WMCDeactivateModal");
              this.showModal("WMCSelectionModal");
            }
          });
      }
    },
  },

  mounted() {
    let UserAccessGroup = this.$ProfilePortal;
    if (UserAccessGroup == null) {
      this.$router.push("/");
    }

    /* Company Lookup */
    let LookUpUrlCompany =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersCompany = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "Company" };
    axios
      .post(LookUpUrlCompany, this.LookUpRequest, LookUpHeadersCompany)
      .then((response) => {
        this.companylist = response.data.Values;
        for (let i = 0; i < this.companylist.length; i++) {
          var QuoteStr4 = this.companylist[i][0];
          this.companyArray.push({
            id: QuoteStr4,
            name: this.companylist[i][1],
          });
        }
      });

    /* Location Look Up */

    let LookUpUrlExistingLocation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersExistingLocation = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "Location", RequestVariable: "" };
    axios
      .post(
        LookUpUrlExistingLocation,
        this.LookUpRequest,
        LookUpHeadersExistingLocation
      )
      .then((response) => {
        this.locationList = response.data.Values;
        for (let i = 0; i < this.locationList.length; i++) {
          var QuoteStr4 = this.locationList[i][0];
          this.locationArray.push({
            id: QuoteStr4,
            Address: this.locationList[i][1],
            BuildingName: this.locationList[i][2],
            Country: this.locationList[i][3],
            Region: this.locationList[i][4],
            EscalationName: this.locationList[i][5],
            EscalationEmail: this.locationList[i][6],
            EscalationPhone: this.locationList[i][7],
            Company: this.locationList[i][8],
          });
        }
      });
  },

  data() {
    return {
      DivID: "",
      fName: "",
      lName: "",
      locationsArray: [],
      clCompany: "",
      clDept: "",
      clLocation: "",
      clEmail: "",
      clURN: "",
      UserFirstNameSearch: "",
      UserSurnameSearch: "",
      deactclURN: "",
      deactclFName: "",
      deactclLName: "",
      deactclDept: "",
      deactclLoc: "",
      locAddress: "",
      locTele: "",
      locEscEmail: "",
      locEscName: "",
      locFloor: "",
      locBuildingName: "",
      locArea: "",
      locations: "",
      location: "",
      filteredlocations: "",
      editLocAddress: "",
      editLocBuildingName: "",
      editLocArea: "",
      editLocEscName: "",
      editLocEscEmail: "",
      editLocEscTele: "",
      contactLocation: this.$Location,
      DeviceRequestNo: "",
      userName: this.$FullName,
      BMULocationRemove: "",
      UserURN: this.$UserURN,
      CountriesArray: [],
      RegionsArray: [],
      CountriesList: [],
      RegionsList: [],
      messageforNewLocationEmail: "",
      selectedSearch: "",
      UserProfile: this.$ProfilePortal,
      selectedAction: "",
      locationArray: [],
      locationList: "",
      companyArray: [],
      companyList: "",
      wmcLocation: "",
      wmcEmail: "",
      wmcCompany: "",
      wmcDept: "",
      wmcURN: "",

      wmcSelection: "",
      wmcList: "",
      wmcToDelete: "",
      wmcListArray: [],
    };
  },

  watch: {
    location() {
      this.filterLocations();
    },
  },
};
</script>

<style scoped>
input[type="text"],
input[type="date"],
select {
  width: 100%;
  padding: 7px 7px 7px 7px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 25px;
  background-color: rgb(245, 245, 245);
}

div {
  float: left;
  width: 100%;
  padding: 10px;
}

.container-fluid {
  border-style: none;
}

.card-body {
  border-style: none;
}

.collapse.show {
  border-style: none;
}

.container {
  border-style: none;
}

.row {
  border-style: none;
}
li {
  width: 100%;
}
input {
  margin-bottom: 8px;
}

input[type="number" i] {
  width: 30%;
}

.Auto {
  border: none;
  padding: none;
  margin: none;
}
.AutoDrop {
  width: 130%;
  text-align: left;
  float: right;
}

.locationAutoFill {
  border: none;
  padding: none;
  margin: none;
}

.locationAutoFillSpan {
  border: none;
  width: 50%;
  margin-left: 29%;
}

.locationAutoFillSpan li {
  background-color: whitesmoke;
}

.HandwashLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

.LocationHandwashAutoFillSpan {
  border: none;
  padding-left: 30%;
}

.LocationHandwashAutoFillSpan ul {
  width: 35%;
}

#AGPortalUser {
  margin-left: 10px;
}

.AutoDropDown {
  border: none;
  margin: none;
  padding: none;
}

.EditLocationAutoFillSpan {
  border: none;
}
.EditLocationAutoFillSpan ul {
  border: none;
  margin-left: 1%;
}

.EditLocationAutoFillSpan li {
  background: white;
}

.EditLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

#StaffRoleHide {
  border: none;
}
#LocationHide {
  border: none;
}

#DropdownAGRFIDRole {
  margin-left: 6px;
}

.lightText {
  text-align: center;
}

.LocationUnitAutoFillSpan {
  border: none;
}
.LocationUnitAutoFillSpan ul {
  border: none;
  margin-left: 10%;
}

.LocationUnitAutoFillSpan li {
  background: white;
}
.LocationDropdown {
  border: none;
}

#SubmitButtons {
  border: none;
  text-align: center;
}
.EditLocationDropdown input {
  margin-left: -5px;
}

#CenterButtons {
  text-align: center;
  border: none;
  padding: none;
  margin: none;
}

.tablinksActive {
  width: 25%;
}
.tablinks {
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
  width: 25%;
}

div.tab,
div.tabBottom {
  padding: 0;
}

.tablinksClientAdminActive {
  width: 50%;
}

.tablinksClientAdmin {
  width: 50%;
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
}

div.tabcontent {
  padding: 0;
}

.tablinksDeviceAdminActive {
  width: 25%;
}

.tablinksDeviceAdmin {
  width: 25%;
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
}

/* New Tabs -------------------------------------- New Tabs */

.reportTabLeft,
.reportTab {
  font-size: 14px;
  width: 50%;
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
}

.reportTabRight {
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
  font-size: 14px;
  width: 50%;
}

.reportTabActiveLeft,
.reportTabActiveRight {
  font-size: 14px;
  width: 50%;
}

.reportTabActive {
  width: 50%;
  font-size: 14px;
}

.reportTabActiveLeft:hover,
.reportTabActiveRight:hover,
.reportTabActive:hover {
  background-color: var(--TabActiveHoverColor);
}

.reportTabLeft:hover,
.reportTabRight:hover,
.reportTab:hover {
  background-color: var(--TabHoverColor);
}
.AdminButton:hover {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
  background-color: black;
}
.AdminButton {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
  background-color: black;
}
</style>
